import { useParams } from 'react-router-dom'

import { AsyncBlock } from '../components/AsyncBlock'
import { ProjectHeading } from '../components/ProjectHeading'
import { api, type ChangeOrder } from '../lib/api'
import { fmtCents, fmtDate, humanize, statusClass } from '../lib/format'
import { useAsync } from '../lib/useAsync'

function ChangeOrderCard({ co }: { co: ChangeOrder }): JSX.Element {
  return (
    <article className="card co-card">
      <div className="co-head">
        <h3>{co.display_name}</h3>
        <span className={`badge badge-${statusClass(co.status)}`}>
          {humanize(co.status)}
        </span>
      </div>
      <p className="co-desc">{co.description}</p>
      <dl className="detail-grid compact">
        <div className="detail-pair">
          <dt>Amount</dt>
          <dd className="co-amount">{fmtCents(co.amount_cents)}</dd>
        </div>
        <div className="detail-pair">
          <dt>Schedule Impact</dt>
          <dd>
            {co.affects_schedule
              ? `${co.schedule_impact_days ?? 0} day(s)`
              : 'None'}
          </dd>
        </div>
        <div className="detail-pair">
          <dt>Signed</dt>
          <dd>{fmtDate(co.client_signed_at)}</dd>
        </div>
      </dl>
    </article>
  )
}

export function ChangeOrdersPage(): JSX.Element {
  const { projectId = '' } = useParams()
  const state = useAsync(
    () => api.changeOrders(projectId),
    `change-orders-${projectId}`,
  )
  return (
    <div className="page">
      <ProjectHeading projectId={projectId} title="Change Orders" />
      <AsyncBlock
        state={state}
        isEmpty={(d) => d.change_orders.length === 0}
        emptyText="No change orders to show yet."
      >
        {(d) => (
          <div className="card-list">
            {d.change_orders.map((co) => (
              <ChangeOrderCard key={co.id} co={co} />
            ))}
          </div>
        )}
      </AsyncBlock>
    </div>
  )
}
